// DUB-110: post-login redirect storage. The previous implementation persisted
// just the URL string in localStorage with no expiry. Users who hadn't logged
// in for days would re-authenticate and land on a stale bracket URL — often
// with admin-only `?entryId=official` query params left over from a prior
// admin session. We now store { url, savedAt } and ignore anything older than
// 1 hour, and we strip the admin-only entryId param so a normal user doesn't
// get dropped into the official-results view by accident.

const KEY = 'dub_intended_url'
const TTL_MS = 60 * 60 * 1000 // 1 hour

function stripAdminParams(rawUrl) {
  const queryIndex = rawUrl.indexOf('?')
  if (queryIndex === -1) return rawUrl
  const path = rawUrl.slice(0, queryIndex)
  const params = new URLSearchParams(rawUrl.slice(queryIndex + 1))
  if (params.get('entryId') === 'official') params.delete('entryId')
  const remaining = params.toString()
  return remaining ? `${path}?${remaining}` : path
}

export function saveIntendedUrl(rawUrl) {
  if (!rawUrl) return
  try {
    const url = stripAdminParams(rawUrl)
    localStorage.setItem(KEY, JSON.stringify({ url, savedAt: Date.now() }))
  } catch {
    // localStorage unavailable (private mode, quota) — best-effort, ignore.
  }
}

export function readIntendedUrl() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed?.url || typeof parsed.savedAt !== 'number') {
      localStorage.removeItem(KEY)
      return null
    }
    if (Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(KEY)
      return null
    }
    return parsed.url
  } catch {
    // Either localStorage failed or the stored value is from the previous
    // bare-string format. Either way, clear it so we don't keep tripping.
    try { localStorage.removeItem(KEY) } catch { /* ignore */ }
    return null
  }
}

export function clearIntendedUrl() {
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
}
